import LocationListPage from './list'
export default LocationListPage
